export const getIsOdd = ({ gantt, task }, column) =>
  gantt?.oddColsConfig && task.type === 'activitytask' // Assuming similar logic for now
    ? gantt.oddColsConfig[column]
    : false;

export const getIsOnlyReadElement = (onlyRead, task, subtradeRole) =>
  onlyRead || task.readonly || (subtradeRole && subtradeRole.isSubtradeRole); // Assuming similar logic
